import { COURSE_BUNDLES_API } from 'modules/courses/bundles/api/course-bundles-api'
import { BaseApiInterface } from 'modules/digital-product/resources/hooks/use-digital-resources'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

export function useCourseBundlesListAll(shouldFetch?: boolean) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, BaseApiInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data: courseBundlesListAll, mutate } = useControlledSwr(
    () => user && [`${COURSE_BUNDLES_API}/list-all`, RequestModuleEnum.CourseBundle],
    fetcher,
    undefined,
    shouldFetch,
  )

  return { courseBundlesListAll, mutate }
}
